import { useEffect, useRef, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import { BoxArrowUpRight, Pencil, Plus, Trash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import DocumentViewer from "../../components/DocumentViewer/DocumentViewer";
import AddDayBook from "./AddDayBook";
import { Button } from "react-bootstrap";
import API from "../../utility/API-endPoints";

const headers: GridHeader[] = [
    {
        title: "Title",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "title",
    },
    {
        title: "Attachment",
        class: "text-left",
        isSorting: false,
        isAsc: true,
    },
    {
        title: "Record Date",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "record_date",
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: "text-center",
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    },
];

const DayBook = () => {
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const nextOffset = useRef<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<GridRow[]>([]);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
    const [showAddDayBook, setShowAddDayBook] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>({});
    const [dayBookId, setDayBookId] = useState<string>("");
    const [keyword, setKeyword] = useState<string>("");
    const [totalCount, setTotalCount] = useState<number>(0);
    const [showDocumentViewer, setShowDocumentViewer] = useState<boolean>(false);
    const [viewerUrl, setViewerUrl] = useState<string>("");
    const [viewerFileName, setViewerFileName] = useState<string>("");

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "DAY_BOOK"));
        }
    }, [token]);

    const getDayBookList = (
        offset: number,
        keyword?: string,
        startDate?: Date,
        endDate?: Date,
        order_by?: string,
        sort_by?: string
    ) => {
        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) {
            return;
        }
        nextOffset.current == 0 && setIsLoading(true);
        WebService.getAPI({
            action: `${API.DAY_BOOK_LIST}?limit=10&page=${offset ? offset - 1 : 0}&keyword=${keyword ? keyword : ""
                }&sort_by=${order_by ?? "desc"}&order_by=${sort_by ?? "created_at"}&from_date=${startDate ? HelperService.getFormatedDateForSorting(startDate) : ""}&to_date=${endDate ? HelperService.getFormatedDateForSorting(endDate) + " 23:59:59" : ""
                }`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                let rows: GridRow[] = [];
                for (var i in res.list) {
                    let columns: GridColumn[] = [];
                    columns.push({ value: res.list[i].title ? res.list[i].title : "N/A" });
                    columns.push({ value: attachmentColumn(res.list[i]), type: "COMPONENT" });
                    columns.push({ value: res.list[i].record_date ? HelperService.getFormatedDate(res.list[i].record_date) : "N/A" });
                    columns.push({ value: actionList(res.list[i]), type: "COMPONENT" });
                    rows.push({ data: columns });
                }
                setRows(rows);
                setKeyword(keyword ?? "");
                setTotalCount(res.count ?? 0);
            })
            .catch((e) => {
                setIsLoading(false);
            });
    };

    const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
        getDayBookList(
            offset,
            null as any,
            null as any,
            null as any,
            isAscending ? "asc" : "desc",
            key
        );
    };

    const openDocument = (fileName: string, isNewTab: boolean) => {
        if (!isNewTab) {
            setViewerFileName(fileName);
            setViewerUrl("");
            setShowDocumentViewer(true);
        }
        WebService.postAPI({ action: "get/signed-url", body: { key: `day_book_files/${fileName}` } })
            .then((res: any) => {
                if (res && res.signed_url) {
                    if (isNewTab) {
                        window.open(res.signed_url, "_blank");
                    } else {
                        setViewerUrl(res.signed_url);
                    }
                } else {
                    toast.error("Failed to get signed URL");
                }
            })
            .catch((error: any) => { toast.error("Failed to get signed URL"); });
    };

    const attachmentColumn = (data: any) => {
        if (!data.file_name) {
            return <span>N/A</span>;
        }
        return (
            <div className="d-flex align-items-center gap-2">
                <span className="cursor-pointer text-brand" title="View here" onClick={() => openDocument(data.file_name, false)}>
                    {data.file_name}
                </span>
                <BoxArrowUpRight size={14} className="cursor-pointer text-brand" title="Open in new tab" onClick={() => openDocument(data.file_name, true)} />
            </div>
        );
    };

    const actionList = (data: any) => {
        return (
            <div className="action-btns">
                {permissions && permissions.can_update && <>
                    <button
                        className="cursor-pointer  btn-edit btn"
                        onClick={() => onEdit(data)}
                    >
                        {" "}
                        <Pencil />{" "}
                    </button>
                </>}
                {permissions && permissions.can_delete && <button
                    onClick={() => onConfirmDelete(data)}
                    className="cursor-pointer btn btn-delete"
                >
                    {" "}
                    <Trash />{" "}
                </button>}
            </div>
        );
    };

    const onEdit = (val: any) => {
        setEditData(val);
        setShowAddDayBook(true);
    };

    const onConfirmDelete = (val: any) => {
        setDayBookId(val.uuid);
        setDeleteModal(true);
    };

    const onDelete = () => {
        setDeleteModal(false);
        setIsLoading(true);
        WebService.deleteAPI({
            action: `day-book/delete/${dayBookId}`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                toast.success(res.message);
                setDayBookId("");
                getDayBookList(1);
            })
            .catch((e) => {
                setIsLoading(false);
                setDayBookId("");
            });
    };

    const onCloseDayBookModal = (e: boolean) => {
        setShowAddDayBook(false);
        setEditData({});
        e && getDayBookList(1);
    };

    return (
        <>
            <AddDayBook
                isShow={showAddDayBook}
                isClose={(e: boolean) => {
                    onCloseDayBookModal(e);
                }}
                data={editData}
            />
            <DeleteModal
                isShow={showDeleteModal}
                close={() => {
                    setDeleteModal(false);
                }}
                onDelete={() => {
                    onDelete();
                }}
            />
            <DocumentViewer
                isShow={showDocumentViewer}
                close={() => {
                    setShowDocumentViewer(false);
                    setViewerUrl("");
                    setViewerFileName("");
                }}
                url={viewerUrl}
                fileName={viewerFileName}
            />
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center  mb-2"> <PageTitle title="Day Book" backArrow={false} />
                    <div>
                        {permissions && permissions.can_write && <Button
                            className="btn btn-brand-1"
                            onClick={() => {
                                setEditData({});
                                setShowAddDayBook(true);
                            }}
                        >
                            <Plus size={20} className="ms-1" /> Add Day Book
                        </Button>}
                    </div>
                </div>
                <div className="table-card">
                    <Grid
                        rows={rows}
                        showSearch={true}
                        headers={headers}
                        showDateFilter={true}
                        onPageChange={getDayBookList}
                        errorMessage={"No Day Book Logs Found"}
                        ShowLoader={isLoading}
                        onSort={onSortList}
                        count={totalCount}
                    />
                </div>
            </div>}
        </>
    );
};

export default DayBook;
